<template>
    <div id="emergence">
        <div v-for="batch of batches.slice().reverse()" v-bind:key="batch['.key']">
            <div v-if="batch['.key']==id2">
                <div v-for="shipment of shipments.slice().reverse()" v-bind:key="shipment['.key']">
                    <div v-if="shipment['.key']==id">
                       <h4>Shipment ID: {{shipment.id}}, Batch ID: {{batch.counter}}</h4>
                       <h6>Species: {{batch.speciesN}}</h6>
                   </div>
               </div>

               <br>
               <b-row>
                <b-col cols="1" md="1">
                    <b-button @click="decrement(batch, 'good')" variant="outline-primary"><b-icon-dash></b-icon-dash></b-button>
                </b-col>
                <b-col cols="3" md="5">
                    <b-form-input v-model="batch.good" :onchange="update(batch)" id="good" disabled></b-form-input>
                </b-col>
                <b-col cols="1" md="1">
                    <b-button @click="increment(batch, 'good')" variant="danger"><b-icon-plus></b-icon-plus></b-button>
                </b-col>
                <b-col cols="7" md="1">Good Emergence</b-col>
            </b-row>
            <br>
            <b-row>
                <b-col cols="1" md="1">
                    <b-button @click="decrement(batch, 'poor')" variant="outline-primary"><b-icon-dash></b-icon-dash></b-button>
                </b-col>
                <b-col cols="3" md="5">
                    <b-form-input v-model="batch.poor" :onchange="update(batch)" id="poor" disabled></b-form-input>
                </b-col>
                <b-col cols="1" md="1">
                    <b-button @click="increment(batch, 'poor')" variant="danger"><b-icon-plus></b-icon-plus></b-button>
                </b-col>
                <b-col cols="7" md="1">Poor Emergence</b-col>
            </b-row>
            <br>
            <b-row>
                <b-col cols="1" md="1">
                    <b-button @click="decrement(batch, 'noEmergence')" variant="outline-primary"><b-icon-dash></b-icon-dash></b-button>
                </b-col>
                <b-col cols="3" md="5">
                    <b-form-input v-model="batch.noEmergence" :onchange="update(batch)" id="noEmergence" disabled></b-form-input>
                </b-col>
                <b-col cols="1" md="1">
                    <b-button @click="increment(batch, 'noEmergence')" variant="danger"><b-icon-plus></b-icon-plus></b-button>
                </b-col>
                <b-col cols="7" md="1">No Emergence</b-col>
            </b-row>
            <br>
            <b-row>
                <b-col cols="1" md="1">
                    <b-button @click="decrement(batch, 'diseased')" variant="outline-primary"><b-icon-dash></b-icon-dash></b-button>
                </b-col>
                <b-col cols="3" md="5">
                    <b-form-input v-model="batch.diseased" :onchange="update(batch)" id="diseased" disabled></b-form-input>
                </b-col>
                <b-col cols="1" md="1">
                    <b-button @click="increment(batch, 'diseased')" variant="danger"><b-icon-plus></b-icon-plus></b-button>
                </b-col>
                <b-col cols="7" md="1">Diseased</b-col>
            </b-row>
            <br>
            <b-row>
                <b-col cols="1" md="1">
                    <b-button @click="decrement(batch, 'parasites')" variant="outline-primary"><b-icon-dash></b-icon-dash></b-button>
                </b-col>
                <b-col cols="3" md="5">
                    <b-form-input v-model="batch.parasites" :onchange="update(batch)" id="parasites" disabled></b-form-input>
                </b-col>
                <b-col cols="1" md="1">
                    <b-button @click="increment(batch, 'parasites')" variant="danger"><b-icon-plus></b-icon-plus></b-button>
                </b-col>
                <b-col cols="7" md="1">Parasites</b-col>
            </b-row>
            <br>
            <b-row>
                <b-col cols="1" md="1">
                    <b-button @click="decrement(batch, 'emerged')" variant="outline-primary"><b-icon-dash></b-icon-dash></b-button>
                </b-col>
                <b-col cols="3" md="5">
                    <b-form-input v-model="batch.emerged" :onchange="update(batch)" id="emerged" disabled></b-form-input>
                </b-col>
                <b-col cols="1" md="1">
                    <b-button @click="increment(batch, 'emerged')" variant="danger"><b-icon-plus></b-icon-plus></b-button>
                </b-col>
                <b-col cols="7" md="1">Emerged</b-col>
            </b-row>
            <br>
            <b-row>
                <b-col cols="1" md="1">
                    <b-button @click="decrement(batch, 'damaged')" variant="outline-primary"><b-icon-dash></b-icon-dash></b-button>
                </b-col>
                <b-col cols="3" md="5">
                    <b-form-input v-model="batch.damaged" :onchange="update(batch)" id="damaged" disabled></b-form-input>
                </b-col>
                <b-col cols="1" md="1">
                    <b-button @click="increment(batch, 'damaged')" variant="danger"><b-icon-plus></b-icon-plus></b-button>
                </b-col>
                <b-col cols="7" md="1">Damaged</b-col>
            </b-row>
            <br>
            <b-row>
                <b-col cols="1" md="1">
                    <b-button @click="decrement(batch, 'released')" variant="outline-primary"><b-icon-dash></b-icon-dash></b-button>
                </b-col>
                <b-col cols="3" md="5">
                    <b-form-input v-model="batch.released" :onchange="update(batch)" id="released" disabled></b-form-input>
                </b-col>
                <b-col cols="1" md="1">
                    <b-button @click="increment(batch, 'released')" variant="danger"><b-icon-plus></b-icon-plus></b-button>
                </b-col>
                <b-col cols="7" md="1">Released</b-col>
            </b-row>
        </div>
    </div>
    <div id="snackbar">{{toastMessage}}</div>
</div>
</template>

<style>
#emergence {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    padding: 10px 50px 50px 50px;
}

#snackbar {
    visibility: hidden; /* Hidden by default. Visible on click */
    min-width: 250px; /* Set a default minimum width */
    margin-left: -125px; /* Divide value of min-width by 2 */
    background-color: #333; /* Black background color */
    color: #fff; /* White text color */
    text-align: center; /* Centered text */
    border-radius: 2px; /* Rounded borders */
    padding: 16px; /* Padding */
    position: fixed; /* Sit on top of the screen */
    z-index: 1; /* Add a z-index if needed */
    left: 45%; /* Center the snackbar */
    bottom: 30px; /* 30px from the bottom */
}


#snackbar.show {
    visibility: visible; 
    -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
    animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
}

</style>

<script>
import { batchRef } from '../firebase'
import { shipmentsRef } from '../firebase'
export default {
    name: 'emergence',
    data () {
        return {
            batches: [],
            shipments: [],
            id: null,
            id2: null,
            toastMessage: ''
        }
    },
    firebase: {
        batches: batchRef,
        shipments: shipmentsRef
    },
    created() {
        this.id = this.$route.params.id;
        this.id2 = this.$route.params.id2;
    },
    methods: {
        update(batch) {
            batchRef.child(this.id2).update({good: batch.good, poor: batch.poor, noEmergence: batch.noEmergence, 
                diseased: batch.diseased, parasites: batch.parasites, emerged: batch.emerged, damaged: batch.damaged,
                released: batch.released});
        },
        goShipment(key){
            this.$router.push({name:'batch', params: {id: key}})
        },
        increment(batch, val){
            var currentShipment = null;
            for(let i =0; i<this.shipments.length; i++){
              if(this.shipments[i]['.key']==this.id){
                currentShipment = this.shipments[i];
                }
            }

            if(currentShipment.numberReceived - currentShipment.accountedFor - 1 < 0){
                this.showSnackBar("Total emergences cannot be greater than number received");
                return;
            }


            if(val == 'good'){
                batch.good++;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor+1});
            }else if(val == 'poor'){
                batch.poor++;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor+1});
            }else if(val == 'noEmergence'){
                batch.noEmergence++;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor+1});
            }else if(val == 'diseased'){
                batch.diseased++;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor+1});
            }else if(val == 'parasites'){
                batch.parasites++;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor+1});
            }else if(val == 'emerged'){
                batch.emerged++;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor+1});
            }else if(val == 'damaged'){
                batch.damaged++;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor+1});
            }else if(val == 'released'){
                batch.released++;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor+1});
            }
            this.update(batch);
        },
        decrement(batch, val){
            var currentShipment = null;
            for(let i =0; i<this.shipments.length; i++){
              if(this.shipments[i]['.key']==this.id){
                currentShipment = this.shipments[i];
            }
        }




        if(val == 'good'){
            if(batch.good>0){
                batch.good--;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor-1});
            }
        }else if(val == 'poor'){
            if(batch.poor>0){
                batch.poor--;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor-1});
            }
        }else if(val == 'noEmergence'){
            if(batch.noEmergence>0){
                batch.noEmergence--;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor-1});
            }   
        }else if(val == 'diseased'){
            if(batch.diseased>0){
                batch.diseased--;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor-1});
            }   

        }else if(val == 'parasites'){
            if(batch.parasites>0){
                batch.parasites--;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor-1});
            }  
        }else if(val == 'emerged'){
            if(batch.emerged>0){
                batch.emerged--;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor-1});
            }  
        }else if(val == 'damaged'){
            if(batch.damaged>0){
                batch.damaged--;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor-1});
            }  
        }else if(val == 'released'){
            if(batch.released>0){
                batch.released--;
                shipmentsRef.child(this.id).update({accountedFor: currentShipment.accountedFor-1});
            }  
        }
        this.update(batch);
    },
    showSnackBar(message){
      this.toastMessage = message;
      var x = document.getElementById("snackbar");
      x.className = "show";
      setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
  }
}
}
</script>